import { Injectable } from '@angular/core';
import { CanActivateChild, CanLoad, Route, Router, UrlSegment, UrlTree } from '@angular/router';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { AuthService } from './auth.service';

@Injectable()
export class AuthGuard implements CanActivate, CanActivateChild, CanLoad {

  constructor(private _authService: AuthService, private _router: Router) { }

  // Can activate
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    const redirectUrl = state.url === '/admin-login' ? '/' : state.url;
    return this._check(redirectUrl);
  }

  // Can activate child
  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const redirectUrl = state.url === '/admin-login' ? '/' : state.url;
    return this._check(redirectUrl);
  }

  // Can load
  canLoad(route: Route, segments: UrlSegment[]): Observable<boolean> | Promise<boolean> | boolean {
    return this._check('/');
  }

  // Check the authenticated status
  private _check(redirectURL: string): Observable<boolean> {
    return this._authService.check().pipe(switchMap((authenticated) => {
      // If the user is not authenticated...
      if (!authenticated) {
        // Redirect to the login page
        this._router.navigate(['/admin-login'], { queryParams: { redirectURL } });

        // Prevent the access
        return of(false);
      }

      // Allow the access
      return of(true);
    }));
  }
}
